import { buildPageTitle } from '@/utils/buildPageTitle'

export default async function ({ app, store, query }) {
  const title = buildPageTitle({ store, i18n: app.i18n, query })
  store.commit('setPageTitle', title)
}
